const Description = ({ description }) => {
  const base = 'text-bodyMobile md:text-bodyDesktop text-olive font-chivoMono mt-smallMobile lg:mt-smallDesktop'
  return <p className={base}>{description}</p>
}

export default Description
